export const SERVER_URL = "http://tvqsolar-iotsolution.net:3005";